import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from '../../css/toasts/RegisterToast.module.css';

const RegisterToast = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [visible, setVisible] = useState(false);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    if (isAuthenticated) return;
    if (sessionStorage.getItem('reg_toast_dismissed')) return;

    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  const dismiss = () => {
    setHiding(true);
    setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem('reg_toast_dismissed', '1');
    }, 250);
  };

  if (!visible || isAuthenticated) return null;

  return (
    <div className={`${styles.toast} ${hiding ? styles.hiding : ''}`}>
      <p className={styles.title}>Зарегистрируйтесь — это бесплатно</p>
      <div className={styles.actions}>
        <Link to="/auth/login" className={styles.btn} onClick={dismiss}>
          Войти
        </Link>
        <button className={styles.close} onClick={dismiss} aria-label="Закрыть">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default RegisterToast;
